import { api } from "@/api/client";
import { convertToURLSearchParams } from "@/util";
import { PaginatedSearch } from "@/types";
import { QualifierUser } from "../user";
import { Region } from "./region";

export enum AddedFrom {
  Waypoint,
}

export type Contractor = {
  id: string;
  name: string;
  addressLine1?: string;
  addressLine2?: string;
  addressLine3?: string;
  country?: string;
  postalCode?: string;
  phoneNumber?: string;
  emailAddress?: string;
  shopOrField?: string;
  addedFrom: AddedFrom;
  creationDate: Date;
  lastUsedDate?: Date;
  weldingSpecialist?: QualifierUser;
  regions?: Region[];
};

export type ContractorListView = {
  id: string;
  name: string;
  regions?: string;
  lastUsedDate?: string;
  shopOrField?: string;
  weldingSpecialist?: string;
  pinned: boolean;
};

export interface ContractorFilters extends PaginatedSearch {
  favorite: boolean;
  searchString: string;
}

export type ContractorValidation = {
  isContractorUnique: boolean;
};

export type ContractorAssociations = {
  owners: QualifierUser[];
  inspectors: QualifierUser[];
  specialists: QualifierUser[];
  favorited: QualifierUser[];
};

export type ContractorMetrics = {
  currentWelders: number;
  weldersTested: number;
  welderTests: number;
  api1104Tests: number;
  asmeTests: number;
  inServiceTests: number;
  testsPassed: number;
  testsFailed: number;
  passRate: number;
};

export function getContractors(filters: Partial<ContractorFilters> = {}) {
  const params = convertToURLSearchParams(filters);
  return api.getPaginated<ContractorListView[]>(`williams/contractors?${params}`);
}

export function getContractorById(id: string) {
  return api.get<Contractor>(`williams/contractors/${id}`);
}

export function saveContractor(contractor: Contractor) {
  return api.post<Contractor>("williams/contractors", contractor);
}

export function validateContractor(contractor: Contractor) {
  return api.post<ContractorValidation>("williams/contractors/validate", contractor);
}

export function togglePinned(id: string) {
  return api.post(`williams/contractors/pin?id=${id}`);
}

export function deleteContractor(id: string) {
  return api.delete(`williams/contractors/${id}`);
}

export function getContractorAssociations(id: string) {
  return api.get<ContractorAssociations>(`williams/contractors/${id}/associations`);
}

export function getContractorMetrics(id: string) {
  return api.get<ContractorMetrics>(`williams/contractors/${id}/metrics`);
}
